import { SEARCH_INSTITUTIONS_SUCCESS } from 'stash/actions/api/bankAccount';

const institutions_search = (state = [], action) => {
  switch (action.type) {
    case SEARCH_INSTITUTIONS_SUCCESS:
      return action.response.institutions;
    default:
      return state;
  }
};

export default institutions_search;
